import { render, staticRenderFns } from "./logo-upload-control.vue?vue&type=template&id=2962e313"
import script from "./logo-upload-control.vue?vue&type=script&lang=js"
export * from "./logo-upload-control.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports